import styled from 'styled-components'

type StyledProps = {
  height: number;
  x: number;
  y: number;
}

const StyledLessonPreviewTooltip = styled.div<StyledProps>`
  pointer-events: none;
  background: #0a0d17d9;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: ${({ theme }) => theme.elevations.modal};
  box-shadow: 0px 8px 16px 2px rgba(97, 97, 97, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;

  .lesson-tooltip-content {
    padding: 30px;
    width: 100%;
    background: ${({ theme }) => theme.colors.background};
    border-radius: 3px;
    z-index: 1;
    position: relative;

    span {
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.07rem;
      color: ${({ theme }) => theme.colors.gray[700]};
    }

    .lesson-bullets {
      padding: 0;
      margin: 25px 0 0 0;
      display: grid;
      grid-gap: 10px;
      list-style-type: none;

      li {
        display: flex;
        color: ${({ theme }) => theme.colors.gray[500]};
        font-weight: 500;
        line-height: 23px;

        svg {
          height: 24px;
          flex-shrink: 0;
          margin-right: 1rem;
        }
      }
    }

    .close-btn {
      position: absolute;
      top: 1rem;
      right: 1rem;
      border-radius: 50%;
      pointer-events: all;
    }
  }

  &::after {
    content: '';
    width: 20px;
    height: 20px;
    background: ${({ theme }) => theme.colors.background};
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    border-radius: 0 0 0 2px;
    border: 1px solid ${({ theme }) => theme.colors.gray[200]};
    display: none;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @media (min-width: ${({ theme }) => `${theme.breakpoints.m}px`}) {
    left: ${({ x }) => x + 5}px;
    top: ${({ height, y }) => y - (height / 2)}px;
    right: unset;
    bottom: unset;
    height: fit-content;
    width: 250px;
    position: absolute;
    transform: unset;
    pointer-events: none;
    background: ${({ theme }) => theme.colors.background};
    border: 1px solid ${({ theme }) => theme.colors.gray[200]};
    border-radius: 3px;
    z-index: ${({ theme }) => theme.elevations.tooltip};
    opacity: 0;
    animation: fade-in 0.3s;
    animation-fill-mode: forwards;
    display: block;
    padding: 0;

    .close-btn {
      display: none;
    }

    .lesson-tooltip-content {
      width: unset;
    }

    &::after {
      display: flex;
    }
  }
`

export default StyledLessonPreviewTooltip
